import React from 'react'

import OAuthConnectView from 'Features/OAuth/Views/OAuthConnect'

export default function OAuthConnectPage() {
  return <OAuthConnectView />
}
